import IService from "@api/iService";
import { IUserTask, IUserTaskMessage } from "@interfaces/user/support";
import {PatchUserTaskMessageModel, UserTaskMessageModel, UserTaskModel} from "@models/user/support";

export default class SupportService extends IService {
    async fetchUserTasks() {
        return await this.getAndThrowApi<IUserTask[]>('/api/user/support/');
    }

    async getTopics() {
        return await this.getApi<IUserTask[]>('/api/user/support/');
    }

    async fetchUserTask(task: string) {
        return await this.getAndThrowApi<IUserTask>(`/api/user/support/${task}/`);
    }

    async getTopic(task: string) {
        return await this.getApi<IUserTask>(`/api/user/support/${task}/`);
    }

    async fetchUserTaskMessages(taskId: string) {
        return await this.getAndThrowApi<IUserTaskMessage[]>(`/api/user/support/${taskId}/messages/`);
    }

    async getTopicMessages(taskId: string) {
        return await this.getApi<IUserTaskMessage[]>(`/api/user/support/${taskId}/messages/`);
    }

    async putUserTask(task: UserTaskModel) {
        return await this.putApi<IUserTask>('/api/user/support/', task);
    }

    async putUserTaskMessage(message: UserTaskMessageModel) {
        return await this.putApi<IUserTaskMessage>(`/api/user/support/${message.task}/messages/`, message);
    }

    async patchUserTaskMessage(taskId: string, messageId: string, message: PatchUserTaskMessageModel) {
        return await this.patchApi<IUserTaskMessage>(`/api/user/support/${taskId}/messages/${messageId}/`, message);
    }

    async deleteUserTaskMessage(taskId: string, messageId: string) {
        return await this.deleteApi(`/api/user/support/${taskId}/messages/${messageId}/`);
    }
}